<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form
        ref="form"
        :model="form"
        :label-width="labelWidth"
        :rules="rules"
        :inline="true"
      >
        <div class="block">
          <div class="contit">基础信息</div>
          <FormItem
            v-for="(c, i) in formCtrl"
            :key="'formItem' + i"
            :viewMode="true"
            :config="c"
            :options="c.options"
            :inputValue="form[c.keyName]"
            @onChange="onChange"
          />
        </div>

        <div class="block">
          <div class="contit">费用信息</div>

          <!-- 第一行 -->
          <div>
            <!-- 加油方式 -->
            <FormItem
              v-for="(c, i) in [formCtrlOrder[0]]"
              :key="`formCtrl${i}_${c.keyName}_${!!c.disabled}`"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />

            <!-- 加油量 -->
            <FormItem
              v-for="(c, i) in formCtrlOrder0"
              :key="`formCtrl${i}_${c.keyName}_${!!c.disabled}`"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />

            <!-- 第二加油方式 -->
            <FormItem
              v-for="(c, i) in [formCtrlOrder2[0]]"
              :key="`formCtrl${i}_${c.keyName}_${!!c.disabled}`"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />
          </div>

          <!-- 第二行 -->
          <div>
            <!-- 加油金额 -->
            <FormItem
              v-for="(c, i) in formCtrlOrder.slice(1, 3)"
              :key="'formO2Item' + i"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />

            <!-- 第二非现金加油 -->
            <FormItem
              v-for="(c, i) in [formCtrlOrder2[1]]"
              :key="`formCtrl${i}_${c.keyName}_${!!c.disabled}`"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />
          </div>

          <!-- 第三行 -->
          <div>
            <!-- 加油票据 -->
            <FormItem
              v-for="(c, i) in formCtrlOrder.slice(3, 5)"
              :key="'formO3Item' + i"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />

            <!-- 第二非现金票据 -->
            <FormItem
              v-for="(c, i) in [formCtrlOrder2[2]]"
              :key="`formCtrl${i}_${c.keyName}_${!!c.disabled}`"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />
          </div>

          <!-- 第二加油方式 -->
          <!-- <div>
            <FormItem
              v-for="(c, i) in formCtrlOrder2"
              :key="'formO3Item2' + i"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />
          </div> -->

          <!-- 第三加油方式 -->
          <div>
            <FormItem
              v-for="(c, i) in [formCtrlOrder3[0]]"
              :key="`formCtrl${i}_${c.keyName}_${!!c.disabled}`"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />
          </div>

          <div>
            <FormItem
              v-for="(c, i) in [formCtrlOrder3[1]]"
              :key="`formCtrl${i}_${c.keyName}_${!!c.disabled}`"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />
          </div>

          <div>
            <FormItem
              v-for="(c, i) in [formCtrlOrder3[2]]"
              :key="`formCtrl${i}_${c.keyName}_${!!c.disabled}`"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />
          </div>

          <!-- <div>
            <FormItem
              v-for="(c, i) in formCtrlOrder3"
              :key="'formO3Item3' + i"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />
          </div> -->

          <div>
            <!-- 里程 -->
            <FormItem
              v-for="(c, i) in formCtrlOrder.slice(5, 7)"
              :key="'formO4Item' + i"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />
          </div>
          <div>
            <!-- 里程票据 -->
            <FormItem
              v-for="(c, i) in formCtrlOrder.slice(7, 9)"
              :key="'formO5Item' + i"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />
          </div>
          <div>
            <!-- '司机提成', '用餐补贴', '住宿补贴' -->
            <FormItem
              v-for="(c, i) in formCtrlOrder01"
              :key="'formO16Item' + i"
              :viewMode="c.viewMode"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />

            <!-- 出车费用系统配置项 -->
            <FormItem
              v-for="(c, i) in formCtrlOrder.slice(9)"
              :key="'formO6Item' + i"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />
          </div>
          <div>
            <FormItem
              v-for="(c, i) in [formCtrl2[0]]"
              :key="'form2_1Item' + i"
              :viewMode="c.viewMode && mode != 'edit'"
              :config="c"
              :options="c.options"
              :inputValue="form[c.keyName]"
              @onChange="onChange"
            />
          </div>
          <!-- 备注 -->
          <FormItem
            v-for="(c, i) in [formCtrl2[1]]"
            :key="'form2Item' + i"
            :viewMode="c.viewMode && mode != 'edit'"
            :config="c"
            :options="c.options"
            :inputValue="form[c.keyName]"
            @onChange="onChange"
          />
          <!-- 合计 -->
          <FormItem
            v-for="(c, i) in [formCtrl2[2]]"
            :key="'form4Item' + i"
            :viewMode="true"
            :config="c"
            :options="c.options"
            :inputValue="form[c.keyName]"
            @onChange="onChange"
          />

          <div v-show="order.is_reject == 1 && order.reject_reason">
            <FormItem
              :viewMode="true"
              :config="rejectCtrl"
              :inputValue="order['reject_reason']"
              @onChange="onChange"
            />
          </div>
        </div>
      </el-form>
    </div>

    <div class="btns">
      <el-button
        v-if="showRejectBtn"
        type="primary"
        class="reject"
        @click="onRejectSubmit"
      >
        驳 回
      </el-button>
      <el-button
        v-if="showExamineBtn"
        type="primary"
        class="examine"
        @click="onCheckSubmit"
      >
        审 核
      </el-button>
      <SubmitBtn
        v-if="user && [1, 2, 3, 4, 5].includes(user.user_group_id) && !viewMode"
        :editMode="true"
        @onSubmit="onSubmit"
      >
      </SubmitBtn>
      <CancelBtn :mode="mode" @onCancel="cancel"></CancelBtn>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import feeMixin from "../feeMixin";

let fromPath = "";

export default {
  mixins: [detailMixin, feeMixin],
  data() {
    return {
      baseUrl: "order",
      breadcrumb: [
        { name: "订单管理", path: "/order/nocontract" },
        { name: "普通订单", path: "/order/nocontract" },
        { name: "出车费用编辑" },
      ],
    };
  },
  methods: {},
  beforeRouteEnter(to, from, next) {
    // console.log(from)
    fromPath = from.fullPath;
    next();
  },
  created() {
    const path = this.$route.path;
    // console.log(path)
    if (path === "/order/contractfee") {
      // 来自订单回收站
      this.breadcrumb[0] = { name: "订单管理", path: fromPath };
      this.breadcrumb[1] = { name: "合同订单", path: fromPath };
    } else if (path === "/order/recyclefee") {
      // 来自订单回收站
      this.breadcrumb[0] = { name: "订单管理", path: fromPath };
      this.breadcrumb[1] = { name: "订单回收站", path: fromPath };
    } else if (path === "/contract/orderFeeDetail") {
      // 来自合同管理-订单列表-雇佣订单
      this.breadcrumb[0] = { name: "合同管理", path: "/contract/list" };
      this.breadcrumb[1] = { name: "合同列表", path: "/contract/list" };
      this.breadcrumb[2] = { name: "订单列表", path: fromPath };
      this.breadcrumb[3] = { name: "出车费用查看" };
    } else if (path === "/finance/abnormalFee") {
      this.breadcrumb[0] = { name: "财务管理", path: fromPath };
      this.breadcrumb[1] = { name: "车辆异常管理", path: fromPath };
      console.log(this.breadcrumb);
    } else if (path === "/finance/feedetails") {
      this.breadcrumb[0] = { name: "财务管理", path: "/finance/expenseSummary" };
      this.breadcrumb[1] = { name: "出车费用汇总表", path: "/finance/expenseSummary" };
      this.breadcrumb[2] = { name: "费用明细", path: fromPath };
      this.breadcrumb[3] = { name: "出车费用查看" };
    } else if (path === "/finance/oilfeedetails") {
      this.breadcrumb[0] = { name: "财务管理", path: fromPath };
      this.breadcrumb[1] = { name: "油气费汇总表", path: fromPath };
    }
  },
};
</script>

<style lang="less" scoped>
.info_form {
  background-color: #fff;
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 5px;

  .contit {
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 0 auto 25px;
    padding: 0 21px;
    font-weight: bold;
    font-size: 18px;
    color: #343434;
  }

  /deep/ .el-form {
    margin-bottom: 20px;

    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;
      display: inline-flex;

      &.unton {
        width: 1000px;
      }

      &.block {
        width: 100%;
        padding-right: 100px;
        margin-right: 0;
        box-sizing: border-box;
      }

      .el-form-item__content {
        flex: 1;

        .el-input,
        .el-textarea,
        .el-date-editor--daterange {
          min-width: 300px;
        }

        .el-textarea {
          width: 300px;
        }

        .unit {
          color: #909399;
        }

        .switch {
          margin-left: 10px;

          .el-switch {
            display: block;

            .el-switch__core {
              margin: 2px auto;
              display: block;
            }

            &.inactive {
              .el-switch__core::after {
                content: "关";
                line-height: 17px;
                text-indent: 18px;
                color: #fff;
              }
            }

            &.active {
              .el-switch__core::after {
                content: "开";
                line-height: 17px;
                text-indent: -16px;
                color: #fff;
              }
            }
          }

          .txt {
            min-width: 50px;
            line-height: 16px;
            font-size: 12px;
            color: #909399;
            margin-top: 3px;
          }
        }
      }
    }
  }

  .el-form:last-child {
    margin-bottom: 0;
  }
}

.btns {
  margin: 40px 0 60px 180px;

  .reject {
    background: #ff4541;
    border-color: #ff4541;
  }

  .examine {
    background: #0fc4b1;
    border-color: #0fc4b1;
  }
}
</style>
